import React from 'react';
import { useDispatch } from 'react-redux';
import useStyles from './styles';
import { Card, Typography, Button } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { Link } from 'react-router-dom';
import { deletePost,getPost } from '../../../actions/posts';
import { useHistory } from 'react-router-dom';



const Post = ({ post, setCurrentId }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const user = JSON.parse(localStorage.getItem('profile'));
  const history = useHistory();


  const openPost = (e) => {
    dispatch(getPost(post._id));
    history.push(`/posts/${post._id}`);
  };


  return (
      <Card className={classes.root}>
        <img
        alt=""
        className={classes.media}
        src={post.pictureURL}
        title={post.title}
        onClick={openPost}
      />
        <section className={classes.name}>
          <div className={classes.title}>
            <Typography variant="h6" onClick={openPost} className={classes.title1}>{post.title}</Typography>
          </div>
          <div className={classes.description}>
            <Typography variant="body2" className={classes.description2}>{post.description.length > 60 ? post.description.slice(0, 60) + "..." : post.description}</Typography>
          </div>
        </section>
        <section className={classes.price}>
          <Typography variant="h6" color="secondary">{post.price} €</Typography>
        </section>
        <section className={classes.city}>
          <Typography variant="subtitle1">{post.city}</Typography>
        </section>
        <section className={classes.category}>
          <Typography variant="body1">{post.category}</Typography>
        </section>
        {(user?.result?._id === post?.creator) && (
        <section className={classes.edit}>
          <Button size="small" color="primary" component={Link} to='/form' onClick={() => setCurrentId(post._id)}> 
          <EditIcon fontSize="small" /> 
          Edit
          </Button>
          <Button size="small" color="secondary" onClick={() => dispatch(deletePost(post._id))}>
          <DeleteIcon fontSize="small" /> 
          Delete
          </Button>
          </section>
        )}
      </Card>
  );
};

export default Post;